import { memo } from 'react';
import { Outlet } from 'react-router';
import PublicSideHeader from './PublicSideHeader';

const PublicLayout = memo(function PublicLayout() {
  return (
    <div className="min-h-svh flex flex-col">
      <PublicSideHeader />
      <div className="p-4 md:p-6 flex-1 flex items-center justify-center">
        <Outlet />
      </div>
    </div>
  );
});

export default PublicLayout;
